// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__k0aqs","header":"ClearentDisclaimer_header__3NtQI","inner":"ClearentDisclaimer_inner__3zc4F"};